import { SVGProps } from 'react';

export const IconCaret = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox='0 0 20 20' {...props}>
      <path d='M7.5 5L7.5 15L12.5 10L7.5 5Z' fill='currentColor' />
    </svg>
  );
};
